
<ng-container >
    <div class="wrapper mt-3" style="height: 75vh;">
        @if(isLoadingData){
        <app-spinner></app-spinner>
        }
        @else {
        <div class="header d-flex row align-items-center">
            <div class="col-md-9">
                <h5 class="px-4 py-3">{{!userData?.userId ? 'Please enter details to create a New EDP' : 'Edit '+ userData.userId +' Details'}}</h5>
            </div>
        </div>
        <form [formGroup]="addEditUserForm">
            <div class="add-category-form p-4 row g-3">
                @for(input of webAccountFields; track input.label){
                @if(input.type == 'input'){
                <div class="col-md-6 mb-2 position-relative ">
                    <label class="form-label">{{input.label}} @if(input.required){<span class="text-danger">*</span>}</label>
                    <input [type]="input.fieldType" class="form-control" placeholder={{input?.placeholder}}
                        formControlName="{{input?.formControlName}}">
                         <span class="error-text"
                            *ngIf="input.required && !addEditUserForm.get(input.formControlName)?.value && (addEditUserForm.get(input.formControlName)?.touched || invalidForm)">
                            {{input?.label}} is required.
                        </span>
                </div>
                }
                @else if(input.type == 'dropdown'){
                <div class="col-md-6 mb-2 d-flex flex-column position-relative">
                    <label class="form-label">{{input.label}}
                        @if(input.required){<span class="text-danger">*</span>}</label>
                    <nz-select nzPlaceHolder="Select" nzSize="default" style="height: 35px !important;"
                        formControlName="{{input?.formControlName}}">

                        <nz-option nzLabel="User" nzValue="U"></nz-option>
                        <nz-option nzLabel="EDP" nzValue="E"></nz-option>
                    </nz-select>
                     <span class="error-text"
                            *ngIf="input.required && !addEditUserForm.get(input.formControlName)?.value && (addEditUserForm.get(input.formControlName)?.touched || invalidForm)">
                            {{input?.label}} is required.
                        </span>
                </div>
                }
                @else if(input.type == 'checkbox'){
                <div class="col-md-6 mb-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="{{input?.formControlName}}">
                        <label class="form-check-label">{{input.label}}</label>
                    </div>
                </div>
                }

                }
            </div>
        </form>
        }
    </div>

</ng-container>